import { WatchLaterTypes } from './types';

const initialState = {
  watchLater: {
    videos: []
  },
  loading: {
    fetchWatchLater: false,
    addToWatchLater: false,
    removeFromWatchLater: false,
    updateTimestamp: false,
    reorderWatchLater: false,
    watchLaterPlayback: false
  },
  error: {
    fetchWatchLater: null,
    addToWatchLater: null,
    removeFromWatchLater: null,
    updateTimestamp: null,
    reorderWatchLater: null,
    watchLaterPlayback: null
  },
  toast: null,
  player: {
    videos: [],
    currentVideoIndex: 0,
    isPlaying: false,
    autoplayEnabled: true
  }
};

export const watchLaterReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch watch later
    case WatchLaterTypes.FETCH_WATCH_LATER_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchWatchLater: true
        },
        error: {
          ...state.error,
          fetchWatchLater: null
        }
      };
      
    case WatchLaterTypes.FETCH_WATCH_LATER_SUCCESS:
      return {
        ...state,
        watchLater: action.payload,
        loading: {
          ...state.loading,
          fetchWatchLater: false
        }
      };
      
    case WatchLaterTypes.FETCH_WATCH_LATER_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchWatchLater: false
        },
        error: {
          ...state.error,
          fetchWatchLater: action.payload
        }
      };
      
    // Add to watch later
    case WatchLaterTypes.ADD_TO_WATCH_LATER_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          addToWatchLater: true
        },
        error: {
          ...state.error,
          addToWatchLater: null
        }
      };
      
    case WatchLaterTypes.ADD_TO_WATCH_LATER_SUCCESS:
      return {
        ...state,
        watchLater: action.payload,
        loading: {
          ...state.loading,
          addToWatchLater: false
        }
      };
      
    case WatchLaterTypes.ADD_TO_WATCH_LATER_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          addToWatchLater: false
        },
        error: {
          ...state.error,
          addToWatchLater: action.payload
        }
      };
      
    // Update timestamp
    case WatchLaterTypes.UPDATE_TIMESTAMP_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateTimestamp: true
        },
        error: {
          ...state.error,
          updateTimestamp: null
        }
      };
      
    case WatchLaterTypes.UPDATE_TIMESTAMP_SUCCESS:
      return {
        ...state,
        watchLater: action.payload,
        loading: {
          ...state.loading,
          updateTimestamp: false
        }
      };
      
    case WatchLaterTypes.UPDATE_TIMESTAMP_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          updateTimestamp: false
        },
        error: {
          ...state.error,
          updateTimestamp: action.payload
        }
      };
      
    // Remove from watch later
    case WatchLaterTypes.REMOVE_FROM_WATCH_LATER_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          removeFromWatchLater: true
        },
        error: {
          ...state.error,
          removeFromWatchLater: null
        }
      };
      
    case WatchLaterTypes.REMOVE_FROM_WATCH_LATER_SUCCESS:
      return {
        ...state,
        watchLater: action.payload,
        loading: {
          ...state.loading,
          removeFromWatchLater: false
        }
      };
      
    case WatchLaterTypes.REMOVE_FROM_WATCH_LATER_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          removeFromWatchLater: false
        },
        error: {
          ...state.error,
          removeFromWatchLater: action.payload
        }
      };
      
    // Reorder watch later
    case WatchLaterTypes.REORDER_WATCH_LATER_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          reorderWatchLater: true
        },
        error: {
          ...state.error,
          reorderWatchLater: null
        }
      };
      
    case WatchLaterTypes.REORDER_WATCH_LATER_SUCCESS:
      return {
        ...state,
        watchLater: action.payload,
        loading: {
          ...state.loading,
          reorderWatchLater: false
        }
      };
      
    case WatchLaterTypes.REORDER_WATCH_LATER_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          reorderWatchLater: false
        },
        error: {
          ...state.error,
          reorderWatchLater: action.payload
        }
      };
      
    // Show toast notification
    case WatchLaterTypes.SHOW_TOAST:
      return {
        ...state,
        toast: action.payload
      };
      
    // Load videos for playback
    case WatchLaterTypes.LOAD_WATCH_LATER_FOR_PLAYBACK_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          watchLaterPlayback: true
        },
        error: {
          ...state.error,
          watchLaterPlayback: null
        }
      };
      
    case WatchLaterTypes.LOAD_WATCH_LATER_FOR_PLAYBACK_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          watchLaterPlayback: false
        },
        player: {
          ...state.player,
          videos: action.payload.videos,
          currentVideoIndex: action.payload.startIndex || 0,
          isPlaying: true
        }
      };
      
    case WatchLaterTypes.LOAD_WATCH_LATER_FOR_PLAYBACK_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          watchLaterPlayback: false
        },
        error: {
          ...state.error,
          watchLaterPlayback: action.payload
        }
      };
      
    // Set playback index
    case WatchLaterTypes.SET_WATCH_LATER_PLAYBACK_INDEX:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: action.payload
        }
      };
      
    // Navigation controls
    case WatchLaterTypes.NEXT_WATCH_LATER_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.min(
            state.player.currentVideoIndex + 1,
            state.player.videos.length - 1
          )
        }
      };
      
    case WatchLaterTypes.PREVIOUS_WATCH_LATER_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.max(0, state.player.currentVideoIndex - 1)
        }
      };
      
    // Toggle autoplay
    case WatchLaterTypes.TOGGLE_WATCH_LATER_AUTOPLAY:
      return {
        ...state,
        player: {
          ...state.player,
          autoplayEnabled: action.payload !== undefined ? action.payload : !state.player.autoplayEnabled
        }
      };
      
    // Clear playback
    case WatchLaterTypes.CLEAR_WATCH_LATER_PLAYBACK:
      return {
        ...state,
        player: {
          videos: [],
          currentVideoIndex: 0,
          isPlaying: false,
          autoplayEnabled: true
        }
      };
      
    default:
      return state;
  }
};

export default watchLaterReducer;
